// one time subscription js start

(function () {
  const FLAVORS = [
    { name: 'Watermelon Apple & Mint' },
    { name: 'Coconut Pineapple & Passion Fruit' }
  ];

  const BUNDLE_GROUP_SELECTOR = '.sls-option-container:has([data-one-time-option-radio])';
  // const BUNDLE_SELLING_PLAN_ID = '714600022401';

  // One-time purchases use the theme's original product-form button.
  // Do not clone or replace it: Shopify must receive the native form submission.

  // ---------------------------------------------------------------------
  // Find the product form dynamically instead of relying on a hardcoded
  // ID (the theme's auto-generated form ID changes between renders).
  // We scope the search to the section/container that holds the bundle
  // widget, and pick the actual add-to-cart form inside it.
  // ---------------------------------------------------------------------
  function getForm() {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return null;

    const scope = bundleContainer.closest('.shopify-section, [id^="product-form-template"]') || document;
    return scope.querySelector('form[action*="/cart/add"]');
  }

  // ---------------------------------------------------------------------
  // Is the bundle plan currently selected?
  // ---------------------------------------------------------------------
  function isBundleActive() {
    const radio = document.querySelector(
      BUNDLE_GROUP_SELECTOR + ' [role="radio"]'
    );

    return radio && radio.getAttribute('aria-checked') === 'true';
  }

  // ---------------------------------------------------------------------
  // Inject the flavour UI's visual styling ONCE as a <style> tag (not as
  // inline styles on each element). Keeps the DOM clean/classes-only while
  // still giving the exact look: full-width, stacked, rounded option
  // buttons with a subtle border, and a highlighted state when selected.
  // ---------------------------------------------------------------------
  function injectStyles() {
    if (document.getElementById('flavor-ui-styles')) return;

    const style = document.createElement('style');
    style.id = 'flavor-ui-styles';
    style.textContent = `
      .flavor-select-container { margin-top: 10px; }
      .flavor-select-title { margin: 6px 0; }
      .flavor-bottle-label {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 12px;
      }
      .flavor-options {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      .flavor-option {
        width: 100%;
        padding: 14px 18px;
        border-radius: 12px;
        border: 1px solid #ddd;
        background: #fff;
        cursor: pointer;
        text-align: left;
        font-size: 15px;
        color: #333;
      }
      .flavor-option:hover {
        border-color: #bbb;
      }
      .flavor-option.active {
        border-color: #ff7f91;
        background: #fff5f6;
        color: #000;
      }
      .flavor-error-msg {
        color: #c0392b;
        font-size: 13px;
        margin: 4px 0;
      }
    `;
    document.head.appendChild(style);
  }

  // ---------------------------------------------------------------------
  // Inject flavour dropdowns into the bundle option box
  // ---------------------------------------------------------------------
  function injectFlavorUI(bundleContainer) {
    if (bundleContainer.querySelector('.flavor-select-container')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'flavor-select-container';
    wrapper.style.display = 'none'; // functional: toggled by updateFlavorVisibility()

    const title = document.createElement('p');
    title.className = 'flavor-select-title';
    title.textContent = 'Choose your flavour:';
    wrapper.appendChild(title);

    for (let i = 1; i <= 1; i++) {
      const label = document.createElement('div');
      label.className = 'flavor-bottle-label';

      // const labelText = document.createElement('span');
      // labelText.textContent = 'Bottle ' + i;
      // label.appendChild(labelText);

      const flavorWrapper = document.createElement('div');

      flavorWrapper.className = 'flavor-options';
      flavorWrapper.dataset.bottleIndex = i;

      FLAVORS.forEach(flavor => {

        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'flavor-option';

        button.textContent = flavor.name;

        button.dataset.flavorName = flavor.name;

        button.addEventListener('click', function () {

          // remove previous active
          flavorWrapper.querySelectorAll('.flavor-option')
            .forEach(btn => btn.classList.remove('active'));

          // active current
          this.classList.add('active');

          // save selected value
          flavorWrapper.dataset.selectedFlavor = flavor.name;

        });

        flavorWrapper.appendChild(button);

      });


      label.appendChild(flavorWrapper);
      wrapper.appendChild(label);
    }

    const errorMsg = document.createElement('p');
    errorMsg.className = 'flavor-error-msg';
    errorMsg.style.display = 'none'; // functional: shown/hidden dynamically in addBundleToCart
    wrapper.appendChild(errorMsg);

    const descriptionEl = bundleContainer.querySelector('.sls-selling-plan-description-content');
    (descriptionEl || bundleContainer).insertAdjacentElement(descriptionEl ? 'afterend' : 'beforeend', wrapper);

    // protectFlavorOptions(wrapper);
  }

  // ---------------------------------------------------------------------
  // Inject a short "1 bottle · 16 daily servings" line directly under the
  // "One-time purchase" label/price row. Plain text only — no radio
  // button involved. Reuses the theme's own description class so it
  // matches typography/spacing automatically.
  //
  // Uses a unique data-attribute (data-custom-serving-info) to detect its
  // own element on repeat MutationObserver runs, same pattern as
  // injectOneTimeSubtitle, so it never duplicates or gets confused with a
  // theme-rendered element that looks similar.
  // ---------------------------------------------------------------------
  function injectServingInfo() {
    const radioContainer = document.querySelector('[data-one-time-option-radio]');
    if (!radioContainer) return;

    const row = radioContainer.closest('.seal-row');
    if (!row) return;

    const labelContainer = row.querySelector('.sls-label-container');
    if (!labelContainer) return;

    const firstLine = labelContainer.querySelector('.sls-selling-plan-group-first-line');
    if (!firstLine) return;

    // const servingText = '16 day supply';
    const servingText = `
<ul class="sls-benefits-list">
  <li class="one-time-supply">16-day supply</li>
  <li>Free delivery</li>
</ul>
`;

    let servingInfo = labelContainer.querySelector('[data-custom-serving-info]');

    if (servingInfo) {
      // Already inserted — refill if it somehow ended up empty
      if (servingInfo.textContent.trim() === '') {
        servingInfo.innerHTML = servingText;
      }
      forceVisible(servingInfo);
      return;
    }

    servingInfo = document.createElement('div');
    // Reuse the theme's existing description class for identical styling,
    // plus a unique data-attribute so we can reliably find/detect it later.
    servingInfo.className = 'sls-selling-plan-description-content serving-info-line';
    servingInfo.setAttribute('data-custom-serving-info', 'true');
    servingInfo.textContent = servingText;

    forceVisible(servingInfo);

    // Insert right after the label/price row. Since injectOneTimeSubtitle
    // also inserts "afterend" of firstLine, call order in checkAndInit
    // determines final stacking (see checkAndInit below).
    firstLine.insertAdjacentElement('afterend', servingInfo);
  }

  // ---------------------------------------------------------------------
  // The theme only shows `.sls-selling-plan-description-content` elements
  // when the parent `.sls-option-container` has the `.sls-active` class
  // (i.e. when that plan is the currently selected/checked one). Our
  // injected lines should stay visible REGARDLESS of checked/unchecked
  // state, so we force the relevant CSS properties with !important via
  // inline style, which wins over the theme's stylesheet rule (unless the
  // theme rule is also !important, which is rare).
  // ---------------------------------------------------------------------
  function forceVisible(el) {
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('overflow', 'visible', 'important');
  }

  // ---------------------------------------------------------------------
  // Inject a subtitle under the "One-time purchase" heading so it
  // matches the description text shown under the subscription options
  // (e.g. "Deliver Every 16 days"). We reuse the theme's own
  // `.sls-selling-plan-description-content` class so typography, color
  // and spacing are automatically identical — no custom CSS needed.
  //
  // We identify our own injected element via a unique data-attribute
  // (not just the class name) so it never gets confused with a
  // similar-looking empty div the theme itself might render in the
  // same spot. If the element exists but its text is empty for any
  // reason, we refill it instead of skipping.
  // ---------------------------------------------------------------------
  function injectOneTimeSubtitle() {
    const radioContainer = document.querySelector('[data-one-time-option-radio]');
    if (!radioContainer) return;

    const row = radioContainer.closest('.seal-row');
    if (!row) return;

    const labelContainer = row.querySelector('.sls-label-container');
    if (!labelContainer) return;

    const firstLine = labelContainer.querySelector('.sls-selling-plan-group-first-line');
    if (!firstLine) return;

    let subtitle = labelContainer.querySelector('[data-custom-one-time-subtitle]');

    if (subtitle) {
      // Already inserted — if it somehow ended up empty, refill it
      if (subtitle.textContent.trim() === '') {
        // subtitle.textContent = 'New to Healü? Start here and see visible results in as little as 4 weeks';
      }
      return;
    }

    subtitle = document.createElement('div');
    // Reuse the theme's existing description class for identical styling,
    // plus a unique data-attribute so we can reliably find/detect it later.
    subtitle.className = 'sls-selling-plan-description-content one-time-subtitle';
    subtitle.setAttribute('data-custom-one-time-subtitle', 'true');
    subtitle.textContent = 'New to Healü? Start here and see visible results in as little as 4 weeks';

    firstLine.insertAdjacentElement('afterend', subtitle);
  }

  // ---------------------------------------------------------------------
  // The theme's own variant/option-picker script disables/hides <option>
  // elements elsewhere on the page that share the same value/text as the
  // selected variant option (e.g. "Watermelon Apple & Mint"). Because our
  // injected dropdown options happen to match that same text, they get
  // caught by that logic and become unclickable. This observer watches
  // only our own option elements and immediately undoes any disabled /
  // hidden / inline-style changes made to them by outside scripts.
  // ---------------------------------------------------------------------
  function protectFlavorOptions(wrapper) {
    const fix = () => {
      wrapper.querySelectorAll('.flavor-select option').forEach(opt => {
        if (opt.disabled) opt.disabled = false;
        if (opt.hidden) opt.hidden = false;
        if (opt.style.display === 'none') opt.style.display = '';
      });
    };

    fix();

    const optionObserver = new MutationObserver(fix);
    optionObserver.observe(wrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'hidden', 'style']
    });
  }

  function getErrorMsgEl(form) {
    return form.querySelector('.flavor-error-msg');
  }

  function addBundleToCart(form, btn) {
    // The flavour dropdowns live in the Seal Subscriptions widget block,
    // which is OUTSIDE the <form> element — so we must search the whole
    // document, not just the form, to find them.
    const flavorOptions = Array.from(
      document.querySelector(BUNDLE_GROUP_SELECTOR)
        .querySelectorAll('.flavor-options')
    );
    const errorMsg = document
      .querySelector(BUNDLE_GROUP_SELECTOR)
      .querySelector('.flavor-error-msg');

    const hasEmptySelection = flavorOptions.some(
      option => !option.dataset.selectedFlavor
    );

    if (flavorOptions.length === 0 || hasEmptySelection) {
      if (errorMsg) {
        errorMsg.textContent = 'Please select a flavour for all bottles.';
        errorMsg.style.display = 'block';
      } else {
        alert('Please select a flavour for all bottles.');
      }
      return;
    }
    if (errorMsg) errorMsg.style.display = 'none';


    // Currently selected product variant
    const currentProductId = parseInt(form.querySelector('[name="id"]').value, 10);

    const selectedFlavorNames = flavorOptions
      .sort((a, b) =>
        parseInt(a.dataset.bottleIndex) -
        parseInt(b.dataset.bottleIndex)
      )
      .map(option => option.dataset.selectedFlavor);

    // const flavourText =
    //   "Selected Bottle:\n" +
    //   selectedFlavorNames.map((name, index) => `Bottle ${index + 1}: ${name}`).join("\n");

const flavourText = selectedFlavorNames.join(", ");

    // let items;
    // items = [{
    //   id: currentProductId,
    //   quantity: 1,
    //   properties: {
    //     flavourText
    //   }
    // }];

let items;

items = [{
  id: currentProductId,
  quantity: 1,
  properties: {
     flavourText
  }
}];

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(res => (res.ok ? res.json() : res.json().then(err => { throw err; })))
      .then(async () => {
        const drawer = document.querySelector('.js-cart-drawer');

        try {
          const res = await fetch('/cart.js');
          const cart = await res.json();

          if (typeof drawer.cartRefreshHandler === 'function') {
            drawer.cartRefreshHandler(cart);
          }

          if (typeof drawer.updateFromCartChange === 'function') {
            drawer.updateFromCartChange(cart);
          }

          // drawer.open();
          // document.querySelector('.js-cart-drawer').open

        } catch (e) {
          console.error(e);
          drawer.open();
        }

        // ✅ RESET UI (THIS WAS MISSING)

        // reset dropdowns
        document
          .querySelector(BUNDLE_GROUP_SELECTOR)
          .querySelectorAll('.flavor-options')
          .forEach(option => {

            option.dataset.selectedFlavor = '';

            option.querySelectorAll('.flavor-option')
              .forEach(btn => btn.classList.remove('active'));

          });

        // hide error
        const errorMsg = document.querySelector('.flavor-error-msg');
        if (errorMsg) {
          errorMsg.style.display = 'none';
          errorMsg.textContent = '';
        }

        // reset button
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (errorMsg) {
          errorMsg.textContent = err.description || 'Something went wrong, let’s try again.';
          errorMsg.style.display = 'block';
        }
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  // ---------------------------------------------------------------------
  // One-time purchase must keep Shopify's original Add to Cart button.
  // The selected variant and quantity are already stored in the product form,
  // and a one-time purchase intentionally has no selling_plan value.
  // ---------------------------------------------------------------------

  // ---------------------------------------------------------------------
  // Show the flavour dropdowns only while the bundle plan is the
  // selected/checked option; hide them otherwise.
  // ---------------------------------------------------------------------
  function updateFlavorVisibility(form) {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return;
    const wrapper = bundleContainer.querySelector('.flavor-select-container');
    if (!wrapper) return;
    wrapper.style.display = isBundleActive(form) ? '' : 'none';
  }

  // ---------------------------------------------------------------------
  // Watch the page for the bundle UI appearing / plan switching
  // ---------------------------------------------------------------------
  function checkAndInit() {
    const form = getForm();
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!form || !bundleContainer) return;

    injectStyles();
    injectFlavorUI(bundleContainer);

    // Call order matters here: insertAdjacentElement('afterend', ...) on
    // firstLine always places the newly-inserted element as the very next
    // sibling of firstLine, pushing whatever was already there further
    // down. We call injectOneTimeSubtitle() FIRST (so it lands right after
    // firstLine), then injectServingInfo() SECOND — its element ends up
    // between firstLine and the subtitle, giving final order:
    //   firstLine -> "1 bottle · 16 daily servings" -> "New to Healü..."
    injectOneTimeSubtitle();
    injectServingInfo();

    updateFlavorVisibility(form);
  }

  const observer = new MutationObserver(checkAndInit);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-checked']
  });

  // Run once immediately in case the bundle UI is already in the DOM
  // at script load time (MutationObserver only fires on future mutations).
  checkAndInit();

  document.addEventListener('click', function (e) {
    const oneTimeContainer = e.target.closest(BUNDLE_GROUP_SELECTOR);

    if (oneTimeContainer) {
      setTimeout(function () {
        const form = getForm();

        if (form && isBundleActive()) {
          form
            .querySelectorAll('[name="selling_plan"]')
            .forEach(function (input) {
              input.remove();
            });
        }

        if (form) {
          updateFlavorVisibility(form);
        }
      }, 50);

      return;
    }

    if (e.target.closest('[role="radio"]') || e.target.closest('.sls-option')) {
      setTimeout(function () {
        const form = getForm();
        if (form) {
          updateFlavorVisibility(form);
        }
      }, 50);
    }
  }, true);
})();


// one time subscription js end


// subscribe and save js start like:


(function () {
  const FLAVORS = [
    { name: 'Watermelon Apple & Mint' },
    { name: 'Coconut Pineapple & Passion Fruit' }
  ];

  const BUNDLE_GROUP_SELECTOR = '.sls-option-container[data-selling-plan-group="0"]';
  const BUNDLE_SELLING_PLAN_ID = '2784755970';

  let originalBtn = null; // the theme's real button, with all its original listeners
  let customBtn = null;   // a clone, stripped of listeners, used only in bundle mode

  // ---------------------------------------------------------------------
  // Find the product form dynamically instead of relying on a hardcoded
  // ID (the theme's auto-generated form ID changes between renders).
  // We scope the search to the section/container that holds the bundle
  // widget, and pick the actual add-to-cart form inside it.
  // ---------------------------------------------------------------------
  function getForm() {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return null;

    const scope = bundleContainer.closest('.shopify-section, [id^="product-form-template"]') || document;
    return scope.querySelector('form[action*="/cart/add"]');
  }

  // ---------------------------------------------------------------------
  // Is the bundle plan currently selected?
  // ---------------------------------------------------------------------
  function isBundleActive(form) {
    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value === BUNDLE_SELLING_PLAN_ID) return true;

    if (form.querySelector(BUNDLE_GROUP_SELECTOR + '.sls-active')) return true;

    const ariaRadio = form.querySelector(BUNDLE_GROUP_SELECTOR + ' [role="radio"]');
    if (ariaRadio && ariaRadio.getAttribute('aria-checked') === 'true') return true;

    return false;
  }

  // ---------------------------------------------------------------------
  // Inject flavour dropdowns into the bundle option box
  // ---------------------------------------------------------------------
  function injectFlavorUI(bundleContainer) {
    if (bundleContainer.querySelector('.flavor-select-container')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'flavor-select-container';
    wrapper.style.marginTop = '10px';
    wrapper.style.display = 'none';

    const title = document.createElement('p');
    title.textContent = 'Choose your flavour:';
    title.style.margin = '6px 0';
    wrapper.appendChild(title);

    for (let i = 1; i <= 1; i++) {
      const label = document.createElement('div');
      label.style.cssText = 'display:flex;flex-direction:column;gap:4px;margin-bottom:8px;';

      // const labelText = document.createElement('span');
      // labelText.textContent = 'Bottle ' + i;
      // label.appendChild(labelText);

      const flavorWrapper = document.createElement('div');
      flavorWrapper.className = 'flavor-options';
      flavorWrapper.dataset.bottleIndex = i;
      flavorWrapper.style.cssText = `
  display:flex;
  gap:10px;
  flex-wrap:wrap;
`;

      FLAVORS.forEach(flavor => {

        const optionBtn = document.createElement('button');

        optionBtn.type = 'button';
        optionBtn.className = 'flavor-option';
        optionBtn.textContent = flavor.name;

        optionBtn.dataset.flavorName = flavor.name;

        optionBtn.style.cssText = `
    padding:10px 18px;
    border-radius:25px;
    border:1px solid #ddd;
    background:#fff;
    cursor:pointer;
  `;


        optionBtn.addEventListener('click', function () {

          // remove previous selected
          flavorWrapper
            .querySelectorAll('.flavor-option')
            .forEach(btn => {
              btn.classList.remove('active');
              btn.style.background = '#fff';
              btn.style.color = '#000';
            });


          // select current
          this.classList.add('active');
          this.style.background = '#ff7f91';
          this.style.color = '#fff';


          // store selected value
          flavorWrapper.dataset.selectedFlavor = flavor.name;

        });


        flavorWrapper.appendChild(optionBtn);

      });


      label.appendChild(flavorWrapper);
      wrapper.appendChild(label);
    }

    const errorMsg = document.createElement('p');
    errorMsg.className = 'flavor-error-msg';
    errorMsg.style.cssText = 'color:#c0392b;font-size:13px;margin:4px 0;display:none;';
    wrapper.appendChild(errorMsg);

    
    const descriptionEl = bundleContainer.querySelector('.sls-selling-plan-description-content');
    (descriptionEl || bundleContainer).insertAdjacentElement(descriptionEl ? 'afterend' : 'beforeend', wrapper);

    // protectFlavorOptions(wrapper);
  }

  // ---------------------------------------------------------------------
  // The theme's own variant/option-picker script disables/hides <option>
  // elements elsewhere on the page that share the same value/text as the
  // selected variant option (e.g. "Watermelon Apple & Mint"). Because our
  // injected dropdown options happen to match that same text, they get
  // caught by that logic and become unclickable. This observer watches
  // only our own option elements and immediately undoes any disabled /
  // hidden / inline-style changes made to them by outside scripts.
  // ---------------------------------------------------------------------
  function protectFlavorOptions(wrapper) {
    const fix = () => {
      wrapper.querySelectorAll('.flavor-select option').forEach(opt => {
        if (opt.disabled) opt.disabled = false;
        if (opt.hidden) opt.hidden = false;
        if (opt.style.display === 'none') opt.style.display = '';
      });
    };

    fix();

    const optionObserver = new MutationObserver(fix);
    optionObserver.observe(wrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'hidden', 'style']
    });
  }

  function getErrorMsgEl(form) {
    return form.querySelector('.flavor-error-msg');
  }

  function addBundleToCart(form, btn) {
    // The flavour dropdowns live in the Seal Subscriptions widget block,
    // which is OUTSIDE the <form> element — so we must search the whole
    // document, not just the form, to find them.
    const flavorOptions = Array.from(
      document.querySelector(BUNDLE_GROUP_SELECTOR).querySelectorAll('.flavor-options')
    );
    const errorMsg = document
      .querySelector(BUNDLE_GROUP_SELECTOR)
      .querySelector('.flavor-error-msg');

    const hasEmptySelection = flavorOptions.some(
      option => !option.dataset.selectedFlavor
    );

    if (flavorOptions.length === 0 || hasEmptySelection) {
      if (errorMsg) {
        errorMsg.textContent = 'Please select a flavour for all bottles.';
        errorMsg.style.display = 'block';
      } else {
        alert('Please select a flavour for all bottles.');
      }
      return;
    }
    if (errorMsg) errorMsg.style.display = 'none';

    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : BUNDLE_SELLING_PLAN_ID;
    // Currently selected product variant
    const currentProductId = parseInt(form.querySelector('[name="id"]').value, 10);

    const selectedFlavorNames = flavorOptions.map(option =>
      option.dataset.selectedFlavor
    );

    // const flavourText =
    //   "Selected Bottle:\n" +
    //   selectedFlavorNames.map((name, index) => `Bottle ${index + 1}: ${name}`).join("\n");

 const flavourText = selectedFlavorNames.join(", ");

let items;
    items = [{
      id: currentProductId,
      quantity: 1,
      selling_plan: sellingPlanId,
      properties: {
        "Flavour": flavourText
      }
    }];

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(res => (res.ok ? res.json() : res.json().then(err => { throw err; })))
      .then(async () => {
        const drawer = document.querySelector('.js-cart-drawer');

        try {
          const res = await fetch('/cart.js');
          const cart = await res.json();

          if (typeof drawer.cartRefreshHandler === 'function') {
            drawer.cartRefreshHandler(cart);
          }

          if (typeof drawer.updateFromCartChange === 'function') {
            drawer.updateFromCartChange(cart);
          }

          drawer.open();
          

        } catch (e) {
          console.error(e);
          drawer.open();
        }

        // ✅ RESET UI (THIS WAS MISSING)

        // reset dropdowns
        document
          .querySelector(BUNDLE_GROUP_SELECTOR)
          .querySelectorAll('.flavor-options')
          .forEach(option => {

            option.dataset.selectedFlavor = '';

            option.querySelectorAll('.flavor-option')
              .forEach(btn => {
                btn.classList.remove('active');
                btn.style.background = '#fff';
                btn.style.color = '#000';
              });

          });

        // hide error
        const errorMsg = document.querySelector('.flavor-error-msg');
        if (errorMsg) {
          errorMsg.style.display = 'none';
          errorMsg.textContent = '';
        }

        // reset button
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (errorMsg) {
          errorMsg.textContent = err.description || 'Something went wrong, let’s try again.';
          errorMsg.style.display = 'block';
        }
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  // ---------------------------------------------------------------------
  // Set up the clone once we find the real button
  // ---------------------------------------------------------------------
  function setupButtonSwap(form) {
    if (originalBtn) return; // already done
    const btn = form.querySelector('.add-to-cart');
    if (!btn) return;

    originalBtn = btn;
    customBtn = btn.cloneNode(true);
    customBtn.type = 'submit';
    customBtn.removeAttribute('onclick');
    customBtn.style.display = ''; // ensure it's never left hidden

    customBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      addBundleToCart(form, customBtn);
    });
  }

  // ---------------------------------------------------------------------
  // Swap the button in/out depending on which plan is selected.
  // Visually it's the SAME button (identical clone) — only its wiring differs.
  // Neither button is ever hidden; only one of the two is in the DOM at a time.
  // ---------------------------------------------------------------------
  function syncButtons(form) {
    if (!originalBtn || !customBtn) return;
    const active = isBundleActive(form);

    if (active) {
      if (originalBtn.isConnected) {
        originalBtn.parentNode.replaceChild(customBtn, originalBtn);
      }
    } else {
      if (customBtn.isConnected) {
        customBtn.parentNode.replaceChild(originalBtn, customBtn);
      }
    }
  }

  // ---------------------------------------------------------------------
  // Show the flavour dropdowns only while the bundle plan is the
  // selected/checked option; hide them otherwise.
  // ---------------------------------------------------------------------
  function updateFlavorVisibility(form) {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return;
    const wrapper = bundleContainer.querySelector('.flavor-select-container');
    if (!wrapper) return;
    wrapper.style.display = isBundleActive(form) ? '' : 'none';
  }

  // ---------------------------------------------------------------------
  // Watch the page for the bundle UI appearing / plan switching
  // ---------------------------------------------------------------------
  function checkAndInit() {
    const form = getForm();
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!form || !bundleContainer) return;

    injectFlavorUI(bundleContainer);
    setupButtonSwap(form);
    syncButtons(form);
    updateFlavorVisibility(form);
  }

  const observer = new MutationObserver(checkAndInit);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-checked']
  });

  // Run once immediately in case the bundle UI is already in the DOM
  // at script load time (MutationObserver only fires on future mutations).
  checkAndInit();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[role="radio"]') || e.target.closest('.sls-option')) {
      setTimeout(function () {
        const form = getForm();
        if (form) {
          syncButtons(form);
          updateFlavorVisibility(form);
        }
      }, 50);
    }
  }, true);
})();

//  (function () {
//   const FLAVORS = [
//     { name: 'Watermelon Apple & Mint' },
//     { name: 'Coconut Pineapple & Passion Fruit' }
//   ];

//   const BUNDLE_GROUP_SELECTOR = '.sls-option-container[data-selling-plan-group-id="ccb43adf4b11214494a30251336cfd23e3ad29d0"]';
//   const BUNDLE_SELLING_PLAN_ID = '2784755970';

//   let originalBtn = null; // the theme's real button, with all its original listeners
//   let customBtn = null;   // a clone, stripped of listeners, used only in bundle mode

//   // ---------------------------------------------------------------------
//   // Find the product form dynamically instead of relying on a hardcoded
//   // ID (the theme's auto-generated form ID changes between renders).
//   // We scope the search to the section/container that holds the bundle
//   // widget, and pick the actual add-to-cart form inside it.
//   // ---------------------------------------------------------------------
//   function getForm() {
//     const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
//     if (!bundleContainer) return null;

//     const scope = bundleContainer.closest('.shopify-section, [id^="product-form-template"]') || document;
//     return scope.querySelector('form[action*="/cart/add"]');
//   }

//   // ---------------------------------------------------------------------
//   // Is the bundle plan currently selected?
//   // ---------------------------------------------------------------------
//   function isBundleActive(form) {
//     const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
//     if (sellingPlanInput && sellingPlanInput.value === BUNDLE_SELLING_PLAN_ID) return true;

//     if (form.querySelector(BUNDLE_GROUP_SELECTOR + '.sls-active')) return true;

//     const ariaRadio = form.querySelector(BUNDLE_GROUP_SELECTOR + ' [role="radio"]');
//     if (ariaRadio && ariaRadio.getAttribute('aria-checked') === 'true') return true;

//     return false;
//   }

//   // ---------------------------------------------------------------------
//   // Inject flavour dropdowns into the bundle option box
//   // ---------------------------------------------------------------------
//   function injectFlavorUI(bundleContainer) {
//     if (bundleContainer.querySelector('.flavor-select-container')) return;

//     const wrapper = document.createElement('div');
//     wrapper.className = 'flavor-select-container';
//     wrapper.style.marginTop = '10px';
//     wrapper.style.display = 'none';

//     const title = document.createElement('p');
//     title.textContent = 'Choose your flavour:';
//     title.style.margin = '6px 0';
//     wrapper.appendChild(title);

//     for (let i = 1; i <= 1; i++) {
//       const label = document.createElement('label');
//       label.style.cssText = 'display:flex;flex-direction:column;gap:4px;margin-bottom:8px;';

//       // const labelText = document.createElement('span');
//       // labelText.textContent = 'Bottle ' + i;
//       // label.appendChild(labelText);

//       const flavorWrapper = document.createElement('div');
//       flavorWrapper.className = 'flavor-options';
//       flavorWrapper.dataset.bottleIndex = i;
//       flavorWrapper.style.cssText = `
//   display:flex;
//   gap:10px;
//   flex-wrap:wrap;
// `;

//       FLAVORS.forEach(flavor => {

//         const optionBtn = document.createElement('button');

//         optionBtn.type = 'button';
//         optionBtn.className = 'flavor-option';
//         optionBtn.textContent = flavor.name;

//         optionBtn.dataset.flavorName = flavor.name;

//         optionBtn.style.cssText = `
//     padding:10px 18px;
//     border-radius:25px;
//     border:1px solid #ddd;
//     background:#fff;
//     cursor:pointer;
//   `;


//         optionBtn.addEventListener('click', function () {

//           // remove previous selected
//           flavorWrapper
//             .querySelectorAll('.flavor-option')
//             .forEach(btn => {
//               btn.classList.remove('active');
//               btn.style.background = '#fff';
//               btn.style.color = '#000';
//             });


//           // select current
//           this.classList.add('active');
//           this.style.background = '#ff7f91';
//           this.style.color = '#fff';


//           // store selected value
//           flavorWrapper.dataset.selectedFlavor = flavor.name;

//         });


//         flavorWrapper.appendChild(optionBtn);

//       });


//       label.appendChild(flavorWrapper);
//       wrapper.appendChild(label);
//     }

//     const errorMsg = document.createElement('p');
//     errorMsg.className = 'flavor-error-msg';
//     errorMsg.style.cssText = 'color:#c0392b;font-size:13px;margin:4px 0;display:none;';
//     wrapper.appendChild(errorMsg);

//     const descriptionEl = bundleContainer.querySelector('.sls-selling-plan-description-content');
//     (descriptionEl || bundleContainer).insertAdjacentElement(descriptionEl ? 'afterend' : 'beforeend', wrapper);

//     // protectFlavorOptions(wrapper);
//   }

//   // ---------------------------------------------------------------------
//   // The theme's own variant/option-picker script disables/hides <option>
//   // elements elsewhere on the page that share the same value/text as the
//   // selected variant option (e.g. "Watermelon Apple & Mint"). Because our
//   // injected dropdown options happen to match that same text, they get
//   // caught by that logic and become unclickable. This observer watches
//   // only our own option elements and immediately undoes any disabled /
//   // hidden / inline-style changes made to them by outside scripts.
//   // ---------------------------------------------------------------------
//   function protectFlavorOptions(wrapper) {
//     const fix = () => {
//       wrapper.querySelectorAll('.flavor-select option').forEach(opt => {
//         if (opt.disabled) opt.disabled = false;
//         if (opt.hidden) opt.hidden = false;
//         if (opt.style.display === 'none') opt.style.display = '';
//       });
//     };

//     fix();

//     const optionObserver = new MutationObserver(fix);
//     optionObserver.observe(wrapper, {
//       subtree: true,
//       attributes: true,
//       attributeFilter: ['disabled', 'hidden', 'style']
//     });
//   }

//   function getErrorMsgEl(form) {
//     return form.querySelector('.flavor-error-msg');
//   }

//   function addBundleToCart(form, btn) {
//     // The flavour dropdowns live in the Seal Subscriptions widget block,
//     // which is OUTSIDE the <form> element — so we must search the whole
//     // document, not just the form, to find them.
//     const flavorOptions = Array.from(
//       document.querySelector(BUNDLE_GROUP_SELECTOR).querySelectorAll('.flavor-options')
//     );
//     const errorMsg = document
//       .querySelector(BUNDLE_GROUP_SELECTOR)
//       .querySelector('.flavor-error-msg');

//     const hasEmptySelection = flavorOptions.some(
//       option => !option.dataset.selectedFlavor
//     );

//     if (flavorOptions.length === 0 || hasEmptySelection) {
//       if (errorMsg) {
//         errorMsg.textContent = 'Please select a flavour for all bottles.';
//         errorMsg.style.display = 'block';
//       } else {
//         alert('Please select a flavour for all bottles.');
//       }
//       return;
//     }
//     if (errorMsg) errorMsg.style.display = 'none';

//     const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
//     const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : BUNDLE_SELLING_PLAN_ID;
//     // Currently selected product variant
//     const currentProductId = parseInt(form.querySelector('[name="id"]').value, 10);

//     const selectedFlavorNames = flavorOptions.map(option =>
//       option.dataset.selectedFlavor
//     );

//     const flavourText =
//       "Selected Bottles:\n" +
//       selectedFlavorNames.map((name, index) => `Bottle ${index + 1}: ${name}`).join("\n");

//     let items;
//     items = [{
//       id: currentProductId,
//       quantity: 1,
//       selling_plan: sellingPlanId,
//       properties: {
//         flavourText
//       }
//     }];

//     const originalText = btn.textContent;
//     btn.disabled = true;
//     btn.textContent = 'Adding...';

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//       body: JSON.stringify({ items })
//     })
//       .then(res => (res.ok ? res.json() : res.json().then(err => { throw err; })))
//       .then(async () => {
//         const drawer = document.querySelector('.js-cart-drawer');

//         try {
//           const res = await fetch('/cart.js');
//           const cart = await res.json();

//           if (typeof drawer.cartRefreshHandler === 'function') {
//             drawer.cartRefreshHandler(cart);
//           }

//           if (typeof drawer.updateFromCartChange === 'function') {
//             drawer.updateFromCartChange(cart);
//           }

//           drawer.open();

//         } catch (e) {
//           console.error(e);
//           drawer.open();
//         }

//         // ✅ RESET UI (THIS WAS MISSING)

//         // reset dropdowns
//         document
//           .querySelector(BUNDLE_GROUP_SELECTOR)
//           .querySelectorAll('.flavor-options')
//           .forEach(option => {

//             option.dataset.selectedFlavor = '';

//             option.querySelectorAll('.flavor-option')
//               .forEach(btn => {
//                 btn.classList.remove('active');
//                 btn.style.background = '#fff';
//                 btn.style.color = '#000';
//               });

//           });

//         // hide error
//         const errorMsg = document.querySelector('.flavor-error-msg');
//         if (errorMsg) {
//           errorMsg.style.display = 'none';
//           errorMsg.textContent = '';
//         }

//         // reset button
//         btn.disabled = false;
//         btn.textContent = 'Add to cart';
//       })
//       .catch(err => {
//         console.error('Add to cart error:', err);
//         if (errorMsg) {
//           errorMsg.textContent = err.description || 'Something went wrong, let’s try again.';
//           errorMsg.style.display = 'block';
//         }
//         btn.disabled = false;
//         btn.textContent = originalText;
//       });
//   }

//   // ---------------------------------------------------------------------
//   // Set up the clone once we find the real button
//   // ---------------------------------------------------------------------
//   function setupButtonSwap(form) {
//     if (originalBtn) return; // already done
//     const btn = form.querySelector('.add-to-cart');
//     if (!btn) return;

//     originalBtn = btn;
//     customBtn = btn.cloneNode(true);
//     customBtn.type = 'submit';
//     customBtn.removeAttribute('onclick');
//     customBtn.style.display = ''; // ensure it's never left hidden

//     customBtn.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();

//       addBundleToCart(form, customBtn);
//     });
//   }

//   // ---------------------------------------------------------------------
//   // Swap the button in/out depending on which plan is selected.
//   // Visually it's the SAME button (identical clone) — only its wiring differs.
//   // Neither button is ever hidden; only one of the two is in the DOM at a time.
//   // ---------------------------------------------------------------------
//   function syncButtons(form) {
//     if (!originalBtn || !customBtn) return;
//     const active = isBundleActive(form);

//     if (active) {
//       if (originalBtn.isConnected) {
//         originalBtn.parentNode.replaceChild(customBtn, originalBtn);
//       }
//     } else {
//       if (customBtn.isConnected) {
//         customBtn.parentNode.replaceChild(originalBtn, customBtn);
//       }
//     }
//   }

//   // ---------------------------------------------------------------------
//   // Show the flavour dropdowns only while the bundle plan is the
//   // selected/checked option; hide them otherwise.
//   // ---------------------------------------------------------------------
//   function updateFlavorVisibility(form) {
//     const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
//     if (!bundleContainer) return;
//     const wrapper = bundleContainer.querySelector('.flavor-select-container');
//     if (!wrapper) return;
//     wrapper.style.display = isBundleActive(form) ? '' : 'none';
//   }

//   // ---------------------------------------------------------------------
//   // Watch the page for the bundle UI appearing / plan switching
//   // ---------------------------------------------------------------------
//   function checkAndInit() {
//     const form = getForm();
//     const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
//     if (!form || !bundleContainer) return;

//     injectFlavorUI(bundleContainer);
//     setupButtonSwap(form);
//     syncButtons(form);
//     updateFlavorVisibility(form);
//   }

//   const observer = new MutationObserver(checkAndInit);
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//     attributes: true,
//     attributeFilter: ['class', 'aria-checked']
//   });

//   // Run once immediately in case the bundle UI is already in the DOM
//   // at script load time (MutationObserver only fires on future mutations).
//   checkAndInit();

//   document.addEventListener('click', function (e) {
//     if (e.target.closest('[role="radio"]') || e.target.closest('.sls-option')) {
//       setTimeout(function () {
//         const form = getForm();
//         if (form) {
//           syncButtons(form);
//           updateFlavorVisibility(form);
//         }
//       }, 50);
//     }
//   }, true);
// })();


// subscribe and save end


// 2 bottle functionality js




(function () {
  const FLAVORS = [
    { name: 'Watermelon Apple & Mint' },
    { name: 'Coconut Pineapple & Passion Fruit' }
  ];

  const BUNDLE_GROUP_SELECTOR = '.sls-option-container[data-selling-plan-group="2"]';
  const BUNDLE_SELLING_PLAN_ID = '714600120705';

  // ---------------------------------------------------------------------
  // STATIC compare-at price shown as strikethrough next to bundle price
  // ---------------------------------------------------------------------
  const COMPARE_AT_PRICE = 55.00; // <-- change this value if needed

  // ---------------------------------------------------------------------
  // Find the product form dynamically instead of relying on a hardcoded
  // ID (the theme's auto-generated form ID changes between renders).
  // We scope the search to the section/container that holds the bundle
  // widget, and pick the actual add-to-cart form inside it.
  // ---------------------------------------------------------------------
  function getForm() {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return null;

    const scope = bundleContainer.closest('.shopify-section, [id^="product-form-template"]') || document;
    return scope.querySelector('form[action*="/cart/add"]');
  }

  // ---------------------------------------------------------------------
  // Is the bundle plan currently selected?
  // ---------------------------------------------------------------------
  function isBundleActive(form) {
    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value === BUNDLE_SELLING_PLAN_ID) return true;

    if (form.querySelector(BUNDLE_GROUP_SELECTOR + '.sls-active')) return true;

    const ariaRadio = form.querySelector(BUNDLE_GROUP_SELECTOR + ' [role="radio"]');
    if (ariaRadio && ariaRadio.getAttribute('aria-checked') === 'true') return true;

    return false;
  }

  // ---------------------------------------------------------------------
  // Inject flavour dropdowns into the bundle option box
  // ---------------------------------------------------------------------
  function injectFlavorUI(bundleContainer) {
    if (bundleContainer.querySelector('.flavor-select-container')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'flavor-select-container';
    wrapper.style.marginTop = '10px';
    wrapper.style.display = 'none';

    const title = document.createElement('p');
    title.textContent = 'Choose your flavours:';
    title.style.margin = '6px 0';
    wrapper.appendChild(title);

    for (let i = 1; i <= 2; i++) {
      const label = document.createElement('label');
      label.style.cssText = 'display:flex;flex-direction:column;gap:4px;margin-bottom:8px;';

      const labelText = document.createElement('span');
      labelText.textContent = 'Bottle ' + i;
      label.appendChild(labelText);

      const select = document.createElement('select');
      select.className = 'flavor-select';
      select.setAttribute('data-bottle-index', i);
      select.style.cssText = 'padding:6px;cursor:pointer;';

      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = 'Select Flavor';
      select.appendChild(defaultOption);

      FLAVORS.forEach(flavor => {
        const option = document.createElement('option');
        option.value = flavor.name;
        option.textContent = flavor.name;
        option.setAttribute('data-flavor-name', flavor.name);
        select.appendChild(option);
      });

      label.appendChild(select);
      wrapper.appendChild(label);
    }

    const errorMsg = document.createElement('p');
    errorMsg.className = 'flavor-error-msg';
    errorMsg.style.cssText = 'color:#c0392b;font-size:13px;margin:4px 0;display:none;';
    wrapper.appendChild(errorMsg);

    const descriptionEl = bundleContainer.querySelector('.sls-selling-plan-description-content');
    (descriptionEl || bundleContainer).insertAdjacentElement(descriptionEl ? 'afterend' : 'beforeend', wrapper);

    protectFlavorOptions(wrapper);
  }

  // ---------------------------------------------------------------------
  // The theme's own variant/option-picker script disables/hides <option>
  // elements elsewhere on the page that share the same value/text as the
  // selected variant option (e.g. "Watermelon Apple & Mint"). Because our
  // injected dropdown options happen to match that same text, they get
  // caught by that logic and become unclickable. This observer watches
  // only our own option elements and immediately undoes any disabled /
  // hidden / inline-style changes made to them by outside scripts.
  // ---------------------------------------------------------------------
  function protectFlavorOptions(wrapper) {
    const fix = () => {
      wrapper.querySelectorAll('.flavor-select option').forEach(opt => {
        if (opt.disabled) opt.disabled = false;
        if (opt.hidden) opt.hidden = false;
        if (opt.style.display === 'none') opt.style.display = '';
      });
    };

    fix();

    const optionObserver = new MutationObserver(fix);
    optionObserver.observe(wrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'hidden', 'style']
    });
  }

  // ---------------------------------------------------------------------
  // Compare-at price (strikethrough) + savings badge
  // ---------------------------------------------------------------------
  function injectComparePrice(bundleContainer) {
    const priceContainer = bundleContainer.querySelector('.sls-price-container[data-selling-plan-group="2"]');
    if (!priceContainer) return;

    // avoid duplicate injection on re-renders
    if (priceContainer.querySelector('.compare-at-price')) return;

    const moneyEl = priceContainer.querySelector('.money');
    if (!moneyEl) return;

    // extract numeric value from current price text, e.g. "£49.50 GBP" -> 49.50
    const match = moneyEl.textContent.match(/[\d,]+\.?\d*/);
    if (!match) return;
    const currentPrice = parseFloat(match[0].replace(/,/g, ''));

    const savingsAmount = COMPARE_AT_PRICE - currentPrice;
    if (savingsAmount <= 0) return; // nothing to show if no real saving

    const savingsPercent = Math.round((savingsAmount / COMPARE_AT_PRICE) * 100);

    // Compare-at price (strikethrough), inserted before the current price
    const compareEl = document.createElement('span');
    compareEl.className = 'compare-at-price';
    compareEl.style.cssText = 'text-decoration:line-through;color:#999;font-size:13px;margin-right:6px;';
    compareEl.textContent = `£${COMPARE_AT_PRICE.toFixed(2)}`;

    moneyEl.parentNode.insertBefore(compareEl, moneyEl);

    // Savings badge, appended below the price
    const savingsBadge = document.createElement('div');
    savingsBadge.className = 'savings-badge';
    savingsBadge.style.cssText = 'margin-top:4px;font-size:12px;font-weight:600;color:#1a7f37;';
    savingsBadge.textContent = `save £${savingsAmount.toFixed(2)}`;

    priceContainer.appendChild(savingsBadge);
  }

  function getErrorMsgEl(form) {
    return form.querySelector('.flavor-error-msg');
  }

  function addBundleToCart(form, btn) {
    // The flavour dropdowns live in the Seal Subscriptions widget block,
    // which is OUTSIDE the <form> element — so we must search the whole
    // document, not just the form, to find them.
    const flavorSelects = Array.from(
      document.querySelector(
        '.sls-option-container[data-selling-plan-group="2"]'
      ).querySelectorAll('.flavor-select')
    );
    const errorMsg = document
      .querySelector('.sls-option-container[data-selling-plan-group="2"]')
      .querySelector('.flavor-error-msg');

    const hasEmptySelection = flavorSelects.some(select => select.value === '');

    if (flavorSelects.length === 0 || hasEmptySelection) {
      if (errorMsg) {
        errorMsg.textContent = 'Please select a flavour for all bottles.';
        errorMsg.style.display = 'block';
      } else {
        alert('Please select a flavour for all bottles.');
      }
      return;
    }
    if (errorMsg) errorMsg.style.display = 'none';

    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : BUNDLE_SELLING_PLAN_ID;
    // Currently selected product variant
    const currentProductId = parseInt(form.querySelector('[name="id"]').value, 10);

    const selectedFlavorNames = flavorSelects
      .sort((a, b) => parseInt(a.dataset.bottleIndex, 10) - parseInt(b.dataset.bottleIndex, 10))
      .map(select => select.options[select.selectedIndex].getAttribute('data-flavor-name'));

    const flavourText =
      selectedFlavorNames.map((name, index) => `Bottle ${index + 1}: ${name}`).join("\n");

    let items;
    items = [{
      id: currentProductId,
      quantity: 1,
      selling_plan: sellingPlanId,
      properties: {
        "Flavour": flavourText
      }
    }];

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(res => (res.ok ? res.json() : res.json().then(err => { throw err; })))
      .then(async () => {
        const drawer = document.querySelector('.js-cart-drawer');

        try {
          const res = await fetch('/cart.js');
          const cart = await res.json();

          if (typeof drawer.cartRefreshHandler === 'function') {
            drawer.cartRefreshHandler(cart);
          }

          if (typeof drawer.updateFromCartChange === 'function') {
            drawer.updateFromCartChange(cart);
          }

          drawer.open();

        } catch (e) {
          console.error(e);
          drawer.open();
        }

        // reset dropdowns
        document
          .querySelector('.sls-option-container[data-selling-plan-group="2"]')
          .querySelectorAll('.flavor-select')
          .forEach(select => {
            select.value = '';
          });

        // hide error
        const errorMsgAfter = document.querySelector('.flavor-error-msg');
        if (errorMsgAfter) {
          errorMsgAfter.style.display = 'none';
          errorMsgAfter.textContent = '';
        }

        // reset button
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (errorMsg) {
          errorMsg.textContent = err.description || 'Something went wrong, let’s try again.';
          errorMsg.style.display = 'block';
        }
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  // ---------------------------------------------------------------------
  // Show the flavour dropdowns only while the bundle plan is the
  // selected/checked option; hide them otherwise.
  // ---------------------------------------------------------------------
  function updateFlavorVisibility(form) {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return;
    const wrapper = bundleContainer.querySelector('.flavor-select-container');
    if (!wrapper) return;
    wrapper.style.display = isBundleActive(form) ? '' : 'none';
  }

  // ---------------------------------------------------------------------
  // Watch the page for the bundle UI appearing / plan switching
  // ---------------------------------------------------------------------
  function checkAndInit() {
    const form = getForm();
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!form || !bundleContainer) return;

    injectFlavorUI(bundleContainer);
    injectComparePrice(bundleContainer);
    updateFlavorVisibility(form);
  }

  const observer = new MutationObserver(checkAndInit);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-checked']
  });

  // Run once immediately in case the bundle UI is already in the DOM
  // at script load time (MutationObserver only fires on future mutations).
  checkAndInit();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[role="radio"]') || e.target.closest('.sls-option')) {
      setTimeout(function () {
        const form = getForm();
        if (form) {
          updateFlavorVisibility(form);
        }
      }, 50);
    }
  }, true);

  // ---------------------------------------------------------------------
  // Reliable add-to-cart interception: instead of cloning/swapping the
  // button (which breaks whenever the theme re-renders and replaces the
  // button node), we listen for clicks on ANY current ".add-to-cart"
  // button via event delegation on document, in the capture phase. This
  // keeps working no matter how many times the DOM is re-rendered, and
  // guarantees the flavour dropdown values always reach the cart.
  // ---------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.add-to-cart');
    if (!btn) return;

    const form = btn.closest('form') || getForm();
    if (!form) return;

    if (isBundleActive(form)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      addBundleToCart(form, btn);
    }
  }, true);
})();


//reverse js like:

(function keepCombinedRowInPlace() {
  let queued = false;

  function moveCombinedRow() {
    queued = false;

    const combinedRow = document.querySelector('.sls-combined-row');
    const oneTime = document
      .querySelector('input[data-type="one_time"]')
      ?.closest('.sls-option-container');

    if (!combinedRow || !oneTime || oneTime.nextElementSibling === combinedRow) return;

    const currentScrollY = window.scrollY;
    oneTime.after(combinedRow);

    requestAnimationFrame(function () {
      window.scrollTo({ top: currentScrollY, left: 0, behavior: 'auto' });
    });
  }

  function queueMove() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(moveCombinedRow);
  }

  const observer = new MutationObserver(queueMove);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  queueMove();
})();

// 2 bottle functionality end


// 3 bottle functionality start


(function () {
  const FLAVORS = [
    { name: 'Watermelon Apple & Mint' },
    { name: 'Coconut Pineapple & Passion Fruit' }
  ];

  const BUNDLE_GROUP_SELECTOR = '.sls-option-container[data-selling-plan-group="1"]';
  const BUNDLE_SELLING_PLAN_ID = '714600022401';

  // ---------------------------------------------------------------------
  // STATIC compare-at price shown as strikethrough next to bundle price
  // ---------------------------------------------------------------------
  const COMPARE_AT_PRICE = 82.50; // <-- change this value if needed

  // ---------------------------------------------------------------------
  // Find the product form dynamically instead of relying on a hardcoded
  // ID (the theme's auto-generated form ID changes between renders).
  // We scope the search to the section/container that holds the bundle
  // widget, and pick the actual add-to-cart form inside it.
  // ---------------------------------------------------------------------
  function getForm() {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return null;

    const scope = bundleContainer.closest('.shopify-section, [id^="product-form-template"]') || document;
    return scope.querySelector('form[action*="/cart/add"]');
  }

  // ---------------------------------------------------------------------
  // Is the bundle plan currently selected?
  // ---------------------------------------------------------------------
  function isBundleActive(form) {
    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value === BUNDLE_SELLING_PLAN_ID) return true;

    if (form.querySelector(BUNDLE_GROUP_SELECTOR + '.sls-active')) return true;

    const ariaRadio = form.querySelector(BUNDLE_GROUP_SELECTOR + ' [role="radio"]');
    if (ariaRadio && ariaRadio.getAttribute('aria-checked') === 'true') return true;

    return false;
  }

  // ---------------------------------------------------------------------
  // Inject flavour dropdowns into the bundle option box
  // ---------------------------------------------------------------------
  function injectFlavorUI(bundleContainer) {
    if (bundleContainer.querySelector('.flavor-select-container')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'flavor-select-container';
    wrapper.style.marginTop = '10px';
    wrapper.style.display = 'none';

    const title = document.createElement('p');
    title.textContent = 'Choose your flavours:';
    title.style.margin = '6px 0';
    wrapper.appendChild(title);

    for (let i = 1; i <= 3; i++) {
      const label = document.createElement('label');
      label.style.cssText = 'display:flex;flex-direction:column;gap:4px;margin-bottom:8px;';

      const labelText = document.createElement('span');
      labelText.textContent = 'Bottle ' + i;
      label.appendChild(labelText);

      const select = document.createElement('select');
      select.className = 'flavor-select';
      select.setAttribute('data-bottle-index', i);
      select.style.cssText = 'padding:6px;cursor:pointer;';

      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = 'Select Flavor';
      select.appendChild(defaultOption);

      FLAVORS.forEach(flavor => {
        const option = document.createElement('option');
        option.value = flavor.name;
        option.textContent = flavor.name;
        option.setAttribute('data-flavor-name', flavor.name);
        select.appendChild(option);
      });

      label.appendChild(select);
      wrapper.appendChild(label);
    }

    const errorMsg = document.createElement('p');
    errorMsg.className = 'flavor-error-msg';
    errorMsg.style.cssText = 'color:#c0392b;font-size:13px;margin:4px 0;display:none;';
    wrapper.appendChild(errorMsg);

    const descriptionEl = bundleContainer.querySelector('.sls-selling-plan-description-content');
    (descriptionEl || bundleContainer).insertAdjacentElement(descriptionEl ? 'afterend' : 'beforeend', wrapper);

    protectFlavorOptions(wrapper);
  }

  // ---------------------------------------------------------------------
  // The theme's own variant/option-picker script disables/hides <option>
  // elements elsewhere on the page that share the same value/text as the
  // selected variant option (e.g. "Watermelon Apple & Mint"). Because our
  // injected dropdown options happen to match that same text, they get
  // caught by that logic and become unclickable. This observer watches
  // only our own option elements and immediately undoes any disabled /
  // hidden / inline-style changes made to them by outside scripts.
  // ---------------------------------------------------------------------
  function protectFlavorOptions(wrapper) {
    const fix = () => {
      wrapper.querySelectorAll('.flavor-select option').forEach(opt => {
        if (opt.disabled) opt.disabled = false;
        if (opt.hidden) opt.hidden = false;
        if (opt.style.display === 'none') opt.style.display = '';
      });
    };

    fix();

    const optionObserver = new MutationObserver(fix);
    optionObserver.observe(wrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'hidden', 'style']
    });
  }

  // ---------------------------------------------------------------------
  // Compare-at price (strikethrough) + savings badge
  // ---------------------------------------------------------------------
  function injectComparePrice(bundleContainer) {
    const priceContainer = bundleContainer.querySelector('.sls-price-container[data-selling-plan-group="1"]');
    if (!priceContainer) return;

    // avoid duplicate injection on re-renders
    if (priceContainer.querySelector('.compare-at-price')) return;

    const moneyEl = priceContainer.querySelector('.money');
    if (!moneyEl) return;

    // extract numeric value from current price text, e.g. "£49.50 GBP" -> 49.50
    const match = moneyEl.textContent.match(/[\d,]+\.?\d*/);
    if (!match) return;
    const currentPrice = parseFloat(match[0].replace(/,/g, ''));

    const savingsAmount = COMPARE_AT_PRICE - currentPrice;
    if (savingsAmount <= 0) return; // nothing to show if no real saving

    const savingsPercent = Math.round((savingsAmount / COMPARE_AT_PRICE) * 100);

    // Compare-at price (strikethrough), inserted before the current price
    const compareEl = document.createElement('span');
    compareEl.className = 'compare-at-price';
    compareEl.style.cssText = 'text-decoration:line-through;color:#999;font-size:13px;margin-right:6px;';
    compareEl.textContent = `£${COMPARE_AT_PRICE.toFixed(2)}`;

    // moneyEl.parentNode.insertBefore(compareEl, moneyEl);

    // Savings badge, appended below the price
    const savingsBadge = document.createElement('div');
    savingsBadge.className = 'savings-badge';
    savingsBadge.style.cssText = 'margin-top:4px;font-size:12px;font-weight:600;color:#1a7f37;';
    savingsBadge.textContent = `save £${savingsAmount.toFixed(2)}`;

    // priceContainer.appendChild(savingsBadge);
  }

  function getErrorMsgEl(form) {
    return form.querySelector('.flavor-error-msg');
  }

  function addBundleToCart(form, btn) {
    // The flavour dropdowns live in the Seal Subscriptions widget block,
    // which is OUTSIDE the <form> element — so we must search the whole
    // document, not just the form, to find them.
    const flavorSelects = Array.from(
      document.querySelector(
        '.sls-option-container[data-selling-plan-group="1"]'
      ).querySelectorAll('.flavor-select')
    );
    const errorMsg = document
      .querySelector('.sls-option-container[data-selling-plan-group="1"]')
      .querySelector('.flavor-error-msg');

    const hasEmptySelection = flavorSelects.some(select => select.value === '');

    if (flavorSelects.length === 0 || hasEmptySelection) {
      if (errorMsg) {
        errorMsg.textContent = 'Please select a flavour for all bottles.';
        errorMsg.style.display = 'block';
      } else {
        alert('Please select a flavour for all bottles.');
      }
      return;
    }
    if (errorMsg) errorMsg.style.display = 'none';

    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : BUNDLE_SELLING_PLAN_ID;
    // Currently selected product variant
    const currentProductId = parseInt(form.querySelector('[name="id"]').value, 10);

    const selectedFlavorNames = flavorSelects
      .sort((a, b) => parseInt(a.dataset.bottleIndex, 10) - parseInt(b.dataset.bottleIndex, 10))
      .map(select => select.options[select.selectedIndex].getAttribute('data-flavor-name'));

    const flavourText =
      selectedFlavorNames.map((name, index) => `Bottle ${index + 1}: ${name}`).join("\n");

    let items;
    items = [{
      id: currentProductId,
      quantity: 1,
      selling_plan: sellingPlanId,
      
    }];

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(res => (res.ok ? res.json() : res.json().then(err => { throw err; })))
      .then(async () => {
        const drawer = document.querySelector('.js-cart-drawer');

        try {
          const res = await fetch('/cart.js');
          const cart = await res.json();

          if (typeof drawer.cartRefreshHandler === 'function') {
            drawer.cartRefreshHandler(cart);
          }

          if (typeof drawer.updateFromCartChange === 'function') {
            drawer.updateFromCartChange(cart);
          }

          drawer.open();
          

        } catch (e) {
          console.error(e);
          drawer.open();
        }

        // reset dropdowns
        document
          .querySelector('.sls-option-container[data-selling-plan-group="1"]')
          .querySelectorAll('.flavor-select')
          .forEach(select => {
            select.value = '';
          });

        // hide error
        const errorMsgAfter = document.querySelector('.flavor-error-msg');
        if (errorMsgAfter) {
          errorMsgAfter.style.display = 'none';
          errorMsgAfter.textContent = '';
        }

        // reset button
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        if (errorMsg) {
          errorMsg.textContent = err.description || 'Something went wrong, let’s try again.';
          errorMsg.style.display = 'block';
        }
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  // ---------------------------------------------------------------------
  // Show the flavour dropdowns only while the bundle plan is the
  // selected/checked option; hide them otherwise.
  // ---------------------------------------------------------------------
  function updateFlavorVisibility(form) {
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!bundleContainer) return;
    const wrapper = bundleContainer.querySelector('.flavor-select-container');
    if (!wrapper) return;
    wrapper.style.display = isBundleActive(form) ? '' : 'none';
  }

  // ---------------------------------------------------------------------
  // Watch the page for the bundle UI appearing / plan switching
  // ---------------------------------------------------------------------
  function checkAndInit() {
    const form = getForm();
    const bundleContainer = document.querySelector(BUNDLE_GROUP_SELECTOR);
    if (!form || !bundleContainer) return;

    injectFlavorUI(bundleContainer);
    injectComparePrice(bundleContainer);
    updateFlavorVisibility(form);
  }

  const observer = new MutationObserver(checkAndInit);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-checked']
  });

  // Run once immediately in case the bundle UI is already in the DOM
  // at script load time (MutationObserver only fires on future mutations).
  checkAndInit();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[role="radio"]') || e.target.closest('.sls-option')) {
      setTimeout(function () {
        const form = getForm();
        if (form) {
          updateFlavorVisibility(form);
        }
      }, 50);
    }
  }, true);

  // ---------------------------------------------------------------------
  // Reliable add-to-cart interception: instead of cloning/swapping the
  // button (which breaks whenever the theme re-renders and replaces the
  // button node), we listen for clicks on ANY current ".add-to-cart"
  // button via event delegation on document, in the capture phase. This
  // keeps working no matter how many times the DOM is re-rendered, and
  // guarantees the flavour dropdown values always reach the cart.
  // ---------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.add-to-cart');
    if (!btn) return;

    const form = btn.closest('form') || getForm();
    if (!form) return;

    if (isBundleActive(form)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      addBundleToCart(form, btn);
    }
  }, true);
})();

document.querySelectorAll('.small-text').forEach(function(item){
    const subscription = item.querySelector('.subscription-description');
    const property = item.querySelector('.line-item-property');

    if(subscription && property){
        subscription.after(property);
    }
});

// 3 bottle functionality end

// ---------------------------------------------------------------------
// Seal purchase-option enhancements
// - correct per-day prices for subscription and one-time modules
// - keep both modules expanded
// - select the matching Subscribe & Save option by default
// - preserve scroll position when the Shopify variant changes
// ---------------------------------------------------------------------
(function () {
  'use strict';

  if (window.__symmetryPurchaseOptionEnhancementsV2) return;
  window.__symmetryPurchaseOptionEnhancementsV2 = true;

  const DAYS_PER_BOTTLE = 16;

  const SUBSCRIPTION_BY_BOTTLES = {
    1: {
      group: '0',
      sellingPlanId: '2784755970'
    },
    2: {
      group: '2',
      sellingPlanId: '714600120705'
    },
    3: {
      group: '1',
      sellingPlanId: '714600022401'
    }
  };

  const BOTTLES_BY_GROUP = {
    '0': 1,
    '2': 2,
    '1': 3
  };

  const VARIANT_CONTROL_SELECTOR = [
    'input[name^="options["]',
    'select[name^="options["]',
    'variant-radios input',
    'variant-selects select',
    '[data-product-option] input',
    '[data-product-option] select'
  ].join(',');

  let lastDefaultedVariantKey = null;
  let refreshQueued = false;
  let defaultSelectionQueued = false;
  let variantScrollY = null;
  let restoreTimers = [];
  let programmaticPlanSelection = false;

  function injectStyles() {
    if (document.getElementById('symmetry-purchase-option-v2-styles')) return;

    const style = document.createElement('style');
    style.id = 'symmetry-purchase-option-v2-styles';
    style.textContent = `
      .sls-option-container .sls-selling-plan-description-content,
      .sls-option-container .sls-selling-plan-description,
      .sls-option-container .sls-description-container,
      [data-custom-one-time-details],
      [data-custom-serving-info] {
        display: block !important;
        visibility: visible !important;
        height: auto !important;
        max-height: none !important;
        overflow: visible !important;
        opacity: 1 !important;
      }
    `;

    document.head.appendChild(style);
  }

  function getProductForm() {
    const purchaseOption =
      document.querySelector('.sls-option-container') ||
      document.querySelector('[data-one-time-option-radio]');

    const scope =
      purchaseOption?.closest(
        '.shopify-section, [id^="product-form-template"]'
      ) || document;

    return scope.querySelector('form[action*="/cart/add"]');
  }

  function parseBottleCount(text) {
    const value = String(text || '');

    if (/\b3\s*bottles?\b/i.test(value)) return 3;
    if (/\b2\s*bottles?\b/i.test(value)) return 2;
    if (/\b1\s*bottle\b/i.test(value)) return 1;

    return null;
  }

  function getSelectedBottleCount() {
    const values = [];

    document
      .querySelectorAll(
        [
          'input[name^="options["]:checked',
          'select[name^="options["]',
          'variant-radios input:checked',
          'variant-selects select',
          '[data-product-option] input:checked',
          '[data-product-option] select'
        ].join(',')
      )
      .forEach(function (control) {
        if (control.tagName === 'SELECT') {
          const selectedOption = control.options[control.selectedIndex];

          values.push(control.value || '');
          values.push(selectedOption?.textContent || '');
        } else {
          values.push(control.value || '');

          const label = control.id
            ? document.querySelector(
                `label[for="${CSS.escape(control.id)}"]`
              )
            : null;

          if (label) values.push(label.textContent || '');
        }
      });

    const fromControls = parseBottleCount(values.join(' '));
    if (fromControls) return fromControls;

    const selectedOptionText = Array.from(
      document.querySelectorAll(
        [
          '.option-selector input:checked + label',
          '.product-form__input input:checked + label',
          '[data-option-value].selected',
          '[data-option-value].active',
          '[aria-pressed="true"]',
          '[aria-selected="true"]'
        ].join(',')
      )
    )
      .filter(function (element) {
        return !element.closest('.sls-option-container');
      })
      .map(function (element) {
        return element.textContent || '';
      })
      .join(' ');

    const fromSelectedText = parseBottleCount(selectedOptionText);
    if (fromSelectedText) return fromSelectedText;

    const form = getProductForm();
    const variantId = form?.querySelector('[name="id"]')?.value || '';

    const productJsonElements = Array.from(
      document.querySelectorAll(
        [
          '[data-product-json]',
          'script[type="application/json"][data-product-json]',
          'script[type="application/json"][id*="ProductJson"]',
          'script[type="application/json"][id*="product-json"]'
        ].join(',')
      )
    );

    for (const element of productJsonElements) {
      try {
        const parsed = JSON.parse(element.textContent || '{}');
        const variants = Array.isArray(parsed)
          ? parsed
          : Array.isArray(parsed.variants)
            ? parsed.variants
            : [];

        const variant = variants.find(function (item) {
          return String(item.id) === String(variantId);
        });

        if (!variant) continue;

        const fromVariant = parseBottleCount(
          [
            variant.title,
            variant.option1,
            variant.option2,
            variant.option3,
            ...(Array.isArray(variant.options) ? variant.options : [])
          ].join(' ')
        );

        if (fromVariant) return fromVariant;
      } catch (error) {
        // Ignore unrelated or malformed JSON blocks.
      }
    }

    const visibleSubscription = Array.from(
      document.querySelectorAll(
        '.sls-option-container[data-selling-plan-group]'
      )
    ).find(function (container) {
      return (
        BOTTLES_BY_GROUP[container.dataset.sellingPlanGroup] &&
        container.offsetParent !== null
      );
    });

    if (visibleSubscription) {
      return (
        BOTTLES_BY_GROUP[
          visibleSubscription.dataset.sellingPlanGroup
        ] || 1
      );
    }

    return 1;
  }

  function parseMoney(text) {
    const token = String(text || '')
      .replace(/\s/g, '')
      .match(/-?\d[\d.,]*/)?.[0];

    if (!token) return null;

    const lastDot = token.lastIndexOf('.');
    const lastComma = token.lastIndexOf(',');
    let normalized = token;

    if (lastDot !== -1 && lastComma !== -1) {
      const decimalSeparator = lastDot > lastComma ? '.' : ',';
      const thousandsSeparator =
        decimalSeparator === '.' ? ',' : '.';

      normalized = token
        .split(thousandsSeparator)
        .join('')
        .replace(decimalSeparator, '.');
    } else if (lastComma !== -1) {
      const decimalLength = token.length - lastComma - 1;
      normalized =
        decimalLength === 2
          ? token.replace(',', '.')
          : token.replace(/,/g, '');
    } else if (lastDot !== -1) {
      const decimalLength = token.length - lastDot - 1;
      normalized =
        decimalLength === 2
          ? token
          : token.replace(/\./g, '');
    }

    const value = Number.parseFloat(normalized);
    return Number.isFinite(value) ? value : null;
  }

  function getCurrencyPrefix(priceText) {
    const numericMatch = String(priceText || '').match(
      /-?\d[\d.,]*/
    );

    if (!numericMatch) return '£';

    const prefix = String(priceText)
      .slice(0, numericMatch.index)
      .trim();

    const currency = prefix.match(/[^\d\s.,-]+/)?.[0];
    return currency || '£';
  }

  function isCompareAtMoney(element) {
    if (!element) return false;

    if (
      element.closest(
        [
          's',
          'del',
          'strike',
          '.compare-at-price',
          '.sls-compare-at-price',
          '[data-compare-price]'
        ].join(',')
      )
    ) {
      return true;
    }

    const className = String(element.className || '');

    if (
      /compare|was-price|old-price|regular-price/i.test(className)
    ) {
      return true;
    }

    try {
      return window
        .getComputedStyle(element)
        .textDecorationLine.includes('line-through');
    } catch (error) {
      return false;
    }
  }

  function findCurrentMoneyElement(priceContainer) {
    const allMoney = Array.from(
      priceContainer.querySelectorAll('.money')
    ).filter(function (element) {
      return (
        !element.closest('.sls-per-day-price') &&
        parseMoney(element.textContent) !== null
      );
    });

    const currentPriceCandidates = allMoney.filter(function (element) {
      return !isCompareAtMoney(element);
    });

    // The discounted/current price is normally the final non-struck value.
    return (
      currentPriceCandidates[currentPriceCandidates.length - 1] ||
      allMoney[allMoney.length - 1] ||
      null
    );
  }

  function isOneTimePriceContainer(priceContainer) {
    const optionContainer = priceContainer.closest(
      '.sls-option-container'
    );

    const row = priceContainer.closest('.seal-row');

    return Boolean(
      optionContainer?.querySelector(
        '[data-one-time-option-radio], input[data-type="one_time"]'
      ) ||
      row?.querySelector(
        '[data-one-time-option-radio], input[data-type="one_time"]'
      )
    );
  }

  // Exact static labels keyed to the actual module total shown by Seal.
  // This does not calculate per-day values and does not depend on the
  // 2-bottle / 3-bottle selling-plan group order.
  const STATIC_MODULE_PRICE_LOOKUP = {
    subscription: [
      { total: 22.50, label: '£1.41/day', pack: 1 },
      { total: 42.00, label: '£1.31/day', pack: 2 },
      { total: 60.00, label: '£1.25/day', pack: 3 }
    ],
    oneTime: [
      { total: 25.00, label: '£1.56/day', pack: 1 },
      { total: 47.50, label: '£1.48/day', pack: 2 },
      { total: 67.50, label: '£1.41/day', pack: 3 }
    ]
  };

  function getAllDisplayedAmounts(priceContainer) {
    const values = [];

    priceContainer
      .querySelectorAll('.money')
      .forEach(function (moneyElement) {
        if (moneyElement.closest('.sls-per-day-price')) return;

        const amount = parseMoney(moneyElement.textContent);

        if (Number.isFinite(amount)) {
          values.push(amount);
        }
      });

    // Fallback for Seal markup where the price is rendered without `.money`.
    if (values.length === 0) {
      const rawMatches = String(priceContainer.textContent || '')
        .match(/-?\d[\d.,]*/g) || [];

      rawMatches.forEach(function (token) {
        const amount = parseMoney(token);

        if (Number.isFinite(amount)) {
          values.push(amount);
        }
      });
    }

    return values;
  }

  function findApprovedStaticPrice(priceContainer, moduleType) {
    const lookup =
      STATIC_MODULE_PRICE_LOOKUP[moduleType] || [];

    const displayedAmounts =
      getAllDisplayedAmounts(priceContainer);

    for (const approved of lookup) {
      const matched = displayedAmounts.some(function (amount) {
        return Math.abs(amount - approved.total) < 0.02;
      });

      if (matched) return approved;
    }

    return null;
  }

  function setStaticPerDayLabel(
    priceContainer,
    approved,
    moduleType
  ) {
    if (!priceContainer || !approved) return;

    let label = priceContainer.querySelector(
      ':scope > .sls-per-day-price'
    );

    if (!label) {
      label = document.createElement('div');
      priceContainer.appendChild(label);
    }

    priceContainer.classList.add(
      'sls-has-per-day-price'
    );

    label.className =
      'sls-per-day-price ' +
      (
        moduleType === 'oneTime'
          ? 'sls-per-day-price--one-time'
          : 'sls-per-day-price--subscription'
      );

    label.dataset.pack = String(approved.pack);
    label.dataset.module = moduleType;
    label.dataset.matchedTotal =
      approved.total.toFixed(2);
    label.dataset.source =
      'exact-static-module-total';

    label.textContent = approved.label;
    label.setAttribute(
      'aria-label',
      approved.label
    );
  }

  function updatePerDayPrices() {
    // Clear every old label before checking the live prices. This prevents
    // a previous 2-bottle or 3-bottle value from being read or reused.
    document
      .querySelectorAll('.sls-per-day-price')
      .forEach(function (label) {
        label.remove();
      });

    document
      .querySelectorAll('.sls-has-per-day-price')
      .forEach(function (container) {
        container.classList.remove(
          'sls-has-per-day-price'
        );
      });

    document
      .querySelectorAll('.sls-price-container')
      .forEach(function (priceContainer) {
        const oneTime =
          isOneTimePriceContainer(priceContainer);

        const moduleType =
          oneTime ? 'oneTime' : 'subscription';

        const approved =
          findApprovedStaticPrice(
            priceContainer,
            moduleType
          );

        if (!approved) return;

        setStaticPerDayLabel(
          priceContainer,
          approved,
          moduleType
        );
      });
  }


  // Update only the one-time supply text for the currently selected pack.
  const ONE_TIME_SUPPLY_BY_TOTAL = [
    { total: 25.00, text: '16-day supply', bottles: 1 },
    { total: 47.50, text: '32-day supply', bottles: 2 },
    { total: 67.50, text: '48-day supply', bottles: 3 }
  ];

  function updateOneTimeSupplyText() {
    const oneTimePriceContainer = Array.from(
      document.querySelectorAll('.sls-price-container')
    ).find(isOneTimePriceContainer);

    let supplyText = null;

    if (oneTimePriceContainer) {
      const displayedAmounts =
        getAllDisplayedAmounts(oneTimePriceContainer);

      const approved = ONE_TIME_SUPPLY_BY_TOTAL.find(function (item) {
        return displayedAmounts.some(function (amount) {
          return Math.abs(amount - item.total) < 0.02;
        });
      });

      if (approved) {
        supplyText = approved.text;
      }
    }

    // Fallback to the selected variant label if Seal has not rendered
    // the one-time price yet.
    if (!supplyText) {
      const bottles = getSelectedBottleCount();

      supplyText = {
        1: '16-day supply',
        2: '32-day supply',
        3: '48-day supply'
      }[bottles] || '16-day supply';
    }

    document
      .querySelectorAll('.one-time-supply')
      .forEach(function (element) {
        if (element.textContent !== supplyText) {
          element.textContent = supplyText;
        }
      });
  }

  function forceElementOpen(element) {
    if (!element) return;

    element.hidden = false;
    element.removeAttribute('aria-hidden');
    element.classList.add('custom-always-visible');

    element.style.setProperty(
      'display',
      'block',
      'important'
    );

    element.style.setProperty(
      'visibility',
      'visible',
      'important'
    );

    element.style.setProperty(
      'height',
      'auto',
      'important'
    );

    element.style.setProperty(
      'max-height',
      'none',
      'important'
    );

    element.style.setProperty(
      'overflow',
      'visible',
      'important'
    );

    element.style.setProperty(
      'opacity',
      '1',
      'important'
    );
  }

  function openBothPurchaseModules() {
    document
      .querySelectorAll('.sls-option-container')
      .forEach(function (container) {
        container
          .querySelectorAll(
            [
              '.sls-selling-plan-description-content',
              '.sls-selling-plan-description',
              '.sls-description-container'
            ].join(',')
          )
          .forEach(forceElementOpen);

        container
          .querySelectorAll('[aria-expanded]')
          .forEach(function (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
          });
      });

    document
      .querySelectorAll(
        '[data-custom-one-time-details], [data-custom-serving-info]'
      )
      .forEach(forceElementOpen);
  }

  function getSubscriptionContainer(bottleCount) {
    const configuration =
      SUBSCRIPTION_BY_BOTTLES[bottleCount] ||
      SUBSCRIPTION_BY_BOTTLES[1];

    return document.querySelector(
      `.sls-option-container[data-selling-plan-group="${configuration.group}"]`
    );
  }

  function getVariantKey() {
    const form = getProductForm();
    const variantId =
      form?.querySelector('[name="id"]')?.value || '';

    return `${variantId}:${getSelectedBottleCount()}`;
  }

  function isSubscriptionSelected(
    form,
    container,
    sellingPlanId
  ) {
    if (!form || !container) return false;

    const currentPlan =
      form.querySelector('input[name="selling_plan"]')
        ?.value || '';

    if (String(currentPlan) === String(sellingPlanId)) {
      return true;
    }

    if (container.classList.contains('sls-active')) {
      return true;
    }

    if (
      container
        .querySelector('[role="radio"]')
        ?.getAttribute('aria-checked') === 'true'
    ) {
      return true;
    }

    return Boolean(
      container.querySelector('input[type="radio"]:checked')
    );
  }

  function applySubscriptionFallback(
    form,
    selectedContainer,
    sellingPlanId
  ) {
    if (!form || !selectedContainer) return;

    let sellingPlanInput =
      form.querySelector('input[name="selling_plan"]');

    if (!sellingPlanInput) {
      sellingPlanInput =
        document.createElement('input');

      sellingPlanInput.type = 'hidden';
      sellingPlanInput.name = 'selling_plan';
      form.appendChild(sellingPlanInput);
    }

    if (
      String(sellingPlanInput.value) !==
      String(sellingPlanId)
    ) {
      sellingPlanInput.value = sellingPlanId;

      sellingPlanInput.dispatchEvent(
        new Event('input', { bubbles: true })
      );

      sellingPlanInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }

    document
      .querySelectorAll('.sls-option-container')
      .forEach(function (container) {
        const isPurchaseOption = Boolean(
          container.hasAttribute(
            'data-selling-plan-group'
          ) ||
          container.querySelector(
            '[data-one-time-option-radio], input[data-type="one_time"]'
          )
        );

        if (!isPurchaseOption) return;

        const selected =
          container === selectedContainer;

        container.classList.toggle(
          'sls-active',
          selected
        );

        container
          .querySelectorAll('[role="radio"]')
          .forEach(function (radio) {
            radio.setAttribute(
              'aria-checked',
              String(selected)
            );
          });

        container
          .querySelectorAll('input[type="radio"]')
          .forEach(function (radio) {
            radio.checked = selected;
          });
      });
  }

  function selectDefaultSubscriptionForVariant() {
    const form = getProductForm();
    if (!form) return false;

    const bottleCount = getSelectedBottleCount();
    const configuration =
      SUBSCRIPTION_BY_BOTTLES[bottleCount] ||
      SUBSCRIPTION_BY_BOTTLES[1];

    const container =
      getSubscriptionContainer(bottleCount);

    if (!container) return false;

    const variantKey = getVariantKey();

    if (
      variantKey === lastDefaultedVariantKey &&
      isSubscriptionSelected(
        form,
        container,
        configuration.sellingPlanId
      )
    ) {
      return true;
    }

    // Do not keep overriding a deliberate purchase-option change.
    if (variantKey === lastDefaultedVariantKey) {
      return true;
    }

    const control =
      container.querySelector('[role="radio"]') ||
      container.querySelector('input[type="radio"]') ||
      container.querySelector('.sls-option') ||
      container.querySelector('.sls-label-container') ||
      container;

    programmaticPlanSelection = true;

    try {
      if (
        !isSubscriptionSelected(
          form,
          container,
          configuration.sellingPlanId
        )
      ) {
        control.click();
      }
    } finally {
      window.setTimeout(function () {
        programmaticPlanSelection = false;
      }, 0);
    }

    lastDefaultedVariantKey = variantKey;

    window.setTimeout(function () {
      if (
        !isSubscriptionSelected(
          form,
          container,
          configuration.sellingPlanId
        )
      ) {
        applySubscriptionFallback(
          form,
          container,
          configuration.sellingPlanId
        );
      }

      openBothPurchaseModules();
      updatePerDayPrices();
    }, 80);

    return true;
  }

  function queueDefaultSubscriptionSelection() {
    if (defaultSelectionQueued) return;

    defaultSelectionQueued = true;

    [40, 140, 320].forEach(function (delay, index) {
      window.setTimeout(function () {
        selectDefaultSubscriptionForVariant();

        if (index === 2) {
          defaultSelectionQueued = false;
        }
      }, delay);
    });
  }

  function clearRestoreTimers() {
    restoreTimers.forEach(clearTimeout);
    restoreTimers = [];
  }

  function restoreVariantScroll(scrollY) {
    clearRestoreTimers();

    [0, 60, 160, 320].forEach(function (delay) {
      restoreTimers.push(
        window.setTimeout(function () {
          window.scrollTo({
            top: scrollY,
            left: 0,
            behavior: 'auto'
          });
        }, delay)
      );
    });
  }

  function getVariantControl(target) {
    if (!(target instanceof Element)) return null;

    const directControl =
      target.closest(VARIANT_CONTROL_SELECTOR);

    if (
      directControl &&
      !directControl.closest('.sls-option-container')
    ) {
      return directControl;
    }

    const label = target.closest('label');

    if (label) {
      const control =
        label.control ||
        (
          label.htmlFor
            ? document.getElementById(label.htmlFor)
            : label.querySelector(
                VARIANT_CONTROL_SELECTOR
              )
        );

      if (
        control?.matches(VARIANT_CONTROL_SELECTOR) &&
        !control.closest('.sls-option-container')
      ) {
        return control;
      }
    }

    return null;
  }

  function refreshPurchaseOptions() {
    injectStyles();
    openBothPurchaseModules();
    updatePerDayPrices();
    updateOneTimeSupplyText();
    selectDefaultSubscriptionForVariant();
  }

  function queueRefresh() {
    if (refreshQueued) return;

    refreshQueued = true;

    window.requestAnimationFrame(function () {
      refreshQueued = false;
      refreshPurchaseOptions();
    });
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (!getVariantControl(event.target)) return;
      variantScrollY = window.scrollY;
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const variantControl =
        getVariantControl(event.target);

      if (variantControl) {
        const anchor =
          event.target.closest('a[href^="#"]');

        if (anchor) event.preventDefault();

        const scrollY =
          variantScrollY === null
            ? window.scrollY
            : variantScrollY;

        restoreVariantScroll(scrollY);

        lastDefaultedVariantKey = null;
        queueDefaultSubscriptionSelection();
        queueRefresh();
        return;
      }

      if (
        !programmaticPlanSelection &&
        event.target.closest(
          '.sls-option-container'
        )
      ) {
        // Preserve the shopper's manual selection until the variant changes.
        lastDefaultedVariantKey = getVariantKey();

        window.setTimeout(function () {
          openBothPurchaseModules();
          updatePerDayPrices();
        }, 60);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target.matches(VARIANT_CONTROL_SELECTOR) &&
        !event.target.closest('.sls-option-container')
      ) {
        const scrollY =
          variantScrollY === null
            ? window.scrollY
            : variantScrollY;

        restoreVariantScroll(scrollY);

        lastDefaultedVariantKey = null;
        queueDefaultSubscriptionSelection();

        [0, 80, 200, 400].forEach(function (delay) {
          window.setTimeout(queueRefresh, delay);
        });

        return;
      }

      if (event.target.closest('.sls-option-container')) {
        window.setTimeout(function () {
          openBothPurchaseModules();
          updatePerDayPrices();
        }, 40);
      }
    },
    true
  );

  [
    'variant:change',
    'product:variant-change',
    'shopify:section:load',
    'shopify:section:reorder'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      lastDefaultedVariantKey = null;
      queueDefaultSubscriptionSelection();
      queueRefresh();
    });
  });

  const observer = new MutationObserver(queueRefresh);

  function start() {
    refreshPurchaseOptions();
    queueDefaultSubscriptionSelection();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        'class',
        'aria-checked',
        'checked',
        'value',
        'data-selling-plan-group'
      ]
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
